import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { webColorUpdate } from "../store/root/rootActions";
import { FiSettings } from "react-icons/fi";
import { FaTimes } from "react-icons/fa";

const CircleIcon = styled.span`
  display: inline-block;
  width: 22px;
  height: 22px;
  background-color: ${({ color, active }) => (!active ? color : `#fff`)};
  border-width: 3px;
  border-style: solid;
  border-color: ${({ color, active }) => (active ? color : `transparent`)};
  border-radius: 50%;
  margin: 5px;
  cursor: pointer;
  transition: 100ms ease-in;
  &:hover {
    transform: scale(1.3);
  }
`;

const CircleInput = styled.input`
  display: inline-block;
  width: 22px;
  height: 22px;
  background-color: ${({ color, active }) => (!active ? color : `#fff`)};
  border-width: 3px;
  border-style: solid;
  border-color: ${({ color, active }) => (active ? color : `transparent`)};
  border-radius: 50%;
  margin: 5px;
  cursor: pointer;
  transition: 100ms ease-in;
  &:hover {
    transform: scale(1.3);
  }
`;

const IconView = styled.div`
  padding: 10px;
  border-bottom-left-radius: 8px;
  background: #0e2431;
`;

export const Text = styled.p`
  color: #fff;
  font-size: 1rem;
  font-weight: 800;
`;

const SettingsIcon = styled.div`
  height: 42px;
  width: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20;
  cursor: pointer;
  color: #fff;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  padding: 8px;
  background: #0e2431;
`;

const View = styled.div`
  position: fixed;
  right: ${({ expand }) => (expand ? `0` : `-165px`)};
  top: 130px;
  display: grid;
  grid-template-columns: auto auto auto;
  transition: right 300ms linear;
  width: 200px;
  z-index: 999;
  @media (max-width: 786px) {
    ${({ show }) => show && `right: -100%`};
  }
`;

const Close = styled.span`
  position: absolute;
  top: 0;
  right: 5px;
  margin: 10px;
  color: ${({ color }) => color};
  cursor: pointer;
`;

const ColorPicker = ({ show }) => {
  const dispatch = useDispatch();
  const webColor = useSelector((state) => state.root.webColor);
  const webActiveColor = useSelector((state) => state.root.activeColor);
  const [webColorActive, setWebColorActive] = useState(webColor);
  const [activeColor, setActiveColor] = useState(webActiveColor);
  const [expand, setExpand] = useState(false);

  const UpdateWebColor = (id) => {
    const CopyWebColorActive = JSON.parse(JSON.stringify(webColorActive));
    let Index = CopyWebColorActive.findIndex((v) => v.id === id);
    CopyWebColorActive.map((v, i) => (CopyWebColorActive[i].active = false));
    if (Index > -1) {
      CopyWebColorActive[Index].active = true;
      setActiveColor(CopyWebColorActive[Index].color);
    }
    setWebColorActive(CopyWebColorActive);
  };

  useEffect(() => {
    dispatch(webColorUpdate(webColorActive, activeColor));
  }, [activeColor, dispatch, webColorActive]);

  return (
    <View expand={expand} show={show}>
      <SettingsIcon expand={expand} onClick={() => setExpand(!expand)}>
        <FiSettings id="settings-icon" />
      </SettingsIcon>
      <IconView>
        <Text>Choose Color</Text>
        <Close onClick={() => setExpand(!expand)} color={activeColor}>
          <FaTimes style={{ fontSize: 20 }} />
        </Close>
        {webColorActive.map(({ id, color, active }) => {
          return (
            <CircleIcon
              color={color}
              active={active ? 1 : undefined}
              key={id}
              expand={expand}
              onClick={UpdateWebColor.bind(this, id)}
            />
          );
        })}
        <CircleInput 
          type="color" 
          id="html5colorpicker" 
          // onChange={(e)=> {setActiveColor(e.target.value)}}
          value={activeColor} 
          />
      </IconView>
    </View>
  );
};

export default React.memo(ColorPicker);
